var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6812_36192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.404 3.63055H10.9581V2.24199C10.9581 1.58083 10.4202 1.04297 9.759 1.04297H6.24074C5.57958 1.04297 5.04169 1.58083 5.04169 2.24199V3.63055H1.59573C0.717892 3.63055 0.00369712 4.34475 0.00369712 5.22258C0.00369712 6.01996 -0.0779641 6.73606 0.526291 7.54138C0.868171 7.997 1.33799 8.32203 1.88492 8.48126L7.19605 10.0276C7.72185 10.1807 8.27774 10.1808 8.80363 10.0276L14.1148 8.48126C14.6617 8.322 15.1315 7.997 15.4734 7.54138C16.0804 6.73244 15.996 6.00898 15.996 5.22258C15.996 4.34475 15.2819 3.63055 14.404 3.63055ZM6.0573 2.24199C6.0573 2.14084 6.13959 2.05858 6.24074 2.05858H9.759C9.86015 2.05858 9.94245 2.14087 9.94245 2.24199V3.63055H6.0573V2.24199Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3989 9.45673C8.67019 11.1247 8.74436 11.1584 8.00005 11.1584C7.26107 11.1584 7.43639 11.1557 1.60124 9.45676C0.986 9.2776 0.441126 8.9474 0.00390625 8.49219V13.3657C0.00390625 14.2435 0.71807 14.9577 1.59594 14.9577H14.4042C15.282 14.9577 15.9962 14.2435 15.9962 13.3657V8.49219C15.559 8.94737 15.0141 9.2776 14.3989 9.45673Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6812_36192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.bd3d84ab7ffb3e7de52795a1d1af14ee.svg";
export { ForwardRef as ReactComponent };